import { render, staticRenderFns } from "./Totalestoque.vue?vue&type=template&id=70009666&"
import script from "./Totalestoque.vue?vue&type=script&lang=js&"
export * from "./Totalestoque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports